(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./userGetters"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./userGetters"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.userGetters);
    global.userUtils = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _userGetters) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.parseLastName = _exports.parseFirstName = void 0;

  /*
   |------------------------------------------------------------------------------
   | Base getters
   |------------------------------------------------------------------------------
   */

  /**
   * Verifies that the user's last name isn't too long for display
   * @param   {User} user - User to get the id from
   * @returns {string} Formatted result
   *
   * @throws Will throw an exception if parameter is not an object
   */
  var parseLastName = function parseLastName(user) {
    var name = (0, _userGetters.getUserLastName)(user);
    var firstLetter = name.substr(0, 1);
    var otherLetters = name.match(/[\s-]\w/g) || [];
    var mergedLetters = "".concat(firstLetter).concat(otherLetters.join(''));
    return mergedLetters;
  };

  /**
   * Verifies that the user's fist name isn't too long for display
   * @param   {User} user - User to get the id from
   * @returns {string} Formatted result
   *
   * @throws Will throw an exception if parameter is not an object
   */
  _exports.parseLastName = parseLastName;
  var parseFirstName = function parseFirstName(user) {
    var lastName = parseLastName(user);
    var name = (0, _userGetters.getUserFirstName)(user);
    if (name.length + lastName.length < 35) {
      return name;
    }
    return name.split(' ')[0];
  };
  _exports.parseFirstName = parseFirstName;
});